var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeCheckedCricle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#F58120"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0183 6.66806L14.0183 6.66797C14.3435 6.34284 14.3435 5.82289 14.0183 5.49775C13.6932 5.17262 13.1733 5.17262 12.8481 5.49775L7.24991 11.096L5.38502 9.23109C5.05988 8.90596 4.53993 8.90596 4.2148 9.23109C3.88966 9.55622 3.88966 10.0762 4.2148 10.4013L6.65896 12.8455C6.98409 13.1706 7.50988 13.1706 7.83502 12.8455L14.0183 6.66806Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeCheckedCricle);
export default __webpack_public_path__ + "static/media/orange-checked-cricle.6b0774f032f265d75d58b2752d7c4760.svg";
export { ForwardRef as ReactComponent };